import { makeStyles } from '@material-ui/core';
import React from 'react';
import CampaignDetailModal from '../../../menu/components/CampaignDetailModal';

const useStyle = makeStyles((theme) => ({
  title: {
    fontWeight: 'bold',
    fontSize: 20,
  },
  item: {
    fontSize: 16,
    marginTop: theme.spacing(1),
  },
}));

export default ({
  isOpend,
  names,
  onClose,
}) => {
  const classes = useStyle();
  return (
    <CampaignDetailModal isOpend={isOpend} onClose={onClose}>
      <div className={classes.title}>可取貨機台列表</div>
      { (names || []).map((name) => <div className={classes.item}>{name}</div>) }
    </CampaignDetailModal>
  );
};
